import { Component, Input, OnInit } from '@angular/core';
import { ValidateSampleSheetError } from '@stratus/gss-ng-sdk';

type Error = {
  message: string
  entry?: string;
};

type GroupedErrors = {
  [key: string]: Error[];
};

export interface SampleSheetError {
  message: string;
  section?: string;
  entry?: string;
}

@Component({
  selector: 'app-sample-sheet-errors',
  templateUrl: './sample-sheet-errors.component.html',
  styleUrls: ['./sample-sheet-errors.component.scss']
})
export class SampleSheetErrorsComponent implements OnInit {
  @Input() errors: ValidateSampleSheetError[] = [];
  groupedErrors: GroupedErrors = {};
  
  constructor() { }

  ngOnInit() {
    this.groupErrors();
  }

  private groupErrors(): void {
    this.groupedErrors = this.errors.reduce((groups: GroupedErrors, error: ValidateSampleSheetError) => {
      const key = error.section || 'General';
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push({ message: error.message, entry: error.entry });
      return groups;
    }, {});
  }
}
